<template>
  <div
    :class="{
      'container mx-auto mt-6': true,
    }"
  >
    <h2>
      {{ title }}
    </h2>
    <p
      :class="{
        'text-center text-xs leading-7 text-www-color-neutral-medium-dark md:text-15px': true,
      }"
    >
      {{ subtitle }}
    </p>

    <slot />
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import { toRefs } from 'vue';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type EduDetailsEducatorSignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/EduDetailsEducatorSignupScreen';
import type { UssProPlan } from '~/sanity/types';

const { signupScreen } = defineProps<
  UssProPlan & {
    signupScreen: EduDetailsEducatorSignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
  }
>();

// Get field references
const eduPositionField = signupScreen.getField(FieldHtmlNameUtil.eduPosition);
const jobTitleField = signupScreen.getField(FieldHtmlNameUtil.jobTitle);
const schoolNameField = signupScreen.getField(FieldHtmlNameUtil.schoolName);
const companyNameField = signupScreen.getField(FieldHtmlNameUtil.companyName);

// Map eduPosition to jobTitle
const eduPositionVal = toRefs(eduPositionField).val;
watch(eduPositionVal, (newVal) => {
  jobTitleField.val = newVal;
});

// Map schoolName to companyName
const schoolNameVal = toRefs(schoolNameField).val;
watch(schoolNameVal, (newVal) => {
  companyNameField.val = newVal;
});
</script>

<style></style>
